import { useQuery, useMutation } from '@tanstack/react-query';
import axios from 'axios';

import { noop, getUrl } from '../lib/serviceHelpers';
import { useUser } from '../contexts/UserContext';

export const useFetchInvitations = (page, search, sortBy, sortDir) => {
  return useQuery(
    ['invitations', { page, search, sortBy, sortDir }],
    async () => {
      const url = getUrl('/invitations', {
        page: page || 1,
        search,
        sortBy,
        sortDir,
      });
      const res = await axios.get(url);
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 5000,
    },
  );
};

export const useFetchInviteByLeadId = (leadId) => {
  return useQuery(
    ['invite-by-lead', leadId],
    async () => {
      if (!leadId) return null;
      const res = await axios.get(`/invitations/by-lead/${leadId}`);
      return res.data;
    },
    {
      enabled: !!leadId,
      refetchOnWindowFocus: false,
      staleTime: 0,
    },
  );
};

export const useFetchAuthInvitation = (inviteId) => {
  return useQuery(
    ['invitations', { inviteId }],
    async () => {
      if (!inviteId) {
        return null;
      }

      const url = getUrl('/auth/invitation', {
        inviteId,
      });
      const res = await axios.get(url);
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 5000,
    },
  );
};

export const useCheckReferralLink = (callback, opts = {}) => {
  return useMutation(
    async (id) => {
      const res = await axios.get(`/public/admins?id=${id}`);
      return res.data;
    },
    { ...opts, onSuccess: callback || noop },
  );
};

export const useExportInvitations = (callback, opts = {}) => {
  const { token } = useUser();

  return useMutation(
    async () => {
      try {
        const res = await axios.get('/invitations/export', {
          responseType: 'blob',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        return res.data;
      } catch (error) {
        console.error('Error exporting invitations:', error);
        // throw error;
      }
    },
    { ...opts, onSuccess: callback || noop },
  );
};
